export const clamp = (num, min, max)=>{
    return Math.max(Math.min(num, max), min);
};

//# sourceMappingURL=clamp.js.map